import { CheckCircle } from "@mui/icons-material";
import { AlertColor, Box, Divider, Grid } from "@mui/material";
import { ChangeEvent, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { BackButton } from "../../../../../components/Button/BackButton/BackButton";
import { KeyDriveDialog } from "../../../../../components/KeydriveComponents/Dialog/KeyDriveDialog";
import { KeyDriveBodyMax } from "../../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMax";
import { KeydriveSimpleModal } from "../../../../../components/KeydriveComponents/Modals/KeydriveSimpleModal";
import { KeydriveTextfield } from "../../../../../components/KeydriveComponents/Textfield/KeydriveTextfield";
import { WorkSpaceCreate, WorkSpaceUpdate } from "../../../../../model/WorkSpaceModel";
import { CreateWorkSpace, Edit, GetOneWorkSpace } from "../../../../../services/WorkSpaceServices";
import { AdminConsoleWrapper } from "../../../components/AdminConsoleWrapper/AdminConsoleWrapper";
import { ConfigWorkspaceHeader } from "./components/ConfigWorkspaceHeader";
import { RuleCard } from "./components/RuleCard";
import {WorkspaceUserConfig} from "../WorkspaceUserConfig/WorkspaceUserConfig";
import KeydriveSnackbar from "../../../../../components/KeydriveComponents/Snackbar/KeydriveSnackbar";
import { useProfile } from "../../../../../context/ProfileProvider/useProfile";

export const ConfigWorkspace = () => {

    const { nameOrg, idWorkspace } = useParams();
    const profile = useProfile();
    const { t } = useTranslation();
    const [workspace, setWorkspace] = useState<WorkSpaceUpdate>({} as WorkSpaceUpdate);
    const [workspaceName, setWorkspaceName] = useState<string>("");
    const [workspaceDescription, setWorkspaceDescription] = useState<string>("");
    const [isUploadAsRealease, setIsUploadAsRealease] = useState<boolean>(false);
    const [isAutomaticCAD, setIsAutomaticCAD] = useState<boolean>(false);
    const [privilegeFollow, setPrivilegeFollow] = useState<boolean>(false);
    const [allUsers, setAllUsers] = useState<string[]>([]);
    const [workspaceCreate, setWorkspaceCreate] = useState<WorkSpaceCreate>({} as WorkSpaceCreate);
    const [requestModal, setRequestModal] = useState<{ requestType: "PUT" | "POST" | "", isLoading: boolean }>({
        isLoading: false,
        requestType: ""
    });
    const [conclusionDialog, setConclusionDialog] = useState<boolean>(false);
    const navigate = useNavigate();
    const [snackMessage, setSnackMesssage] = useState<string>("");
    const [isOpenSnack, setIsOpenSnack] = useState<boolean>(false);
    const [snackSeverity, setSnackSeverity] = useState<AlertColor>("success");

    const handleClose = () => {
        setIsOpenSnack(false);
    };

    useEffect(() => {
        getWorkspace();
    }, [idWorkspace]);

    useEffect(() => {
        setWorkspaceRules();
    }, [workspace])

    useEffect(() => {
        console.log(conclusionDialog);
    }, [conclusionDialog])

    function setWorkspaceRules() : void 
    {
        if (workspace != undefined)
        {
            if (workspace.isUploadAsRealease != undefined)
            {
                setIsUploadAsRealease(workspace.isUploadAsRealease!);
            }

            if (workspace.automaticViwerDwg != undefined)
            {
                setIsAutomaticCAD(workspace.automaticViwerDwg!);
            }

            if (workspace.privilegeFollowWorkspaceRoot !== undefined) {
                setPrivilegeFollow(workspace.privilegeFollowWorkspaceRoot);
            }
        }
    }

    function getWorkspace() : void 
    {
        if (idWorkspace != undefined)
        {
            GetOneWorkSpace(idWorkspace)
            .then(data => {
                if (data != null || data != undefined)
                {
                    setWorkspace(data);
                    setWorkspaceName(data.name!);
                    setWorkspaceDescription(data.organizationName!);
                    setIsAutomaticCAD(data.automaticViwerDwg!);
                    setPrivilegeFollow(data.privilegeFollowWorkspaceRoot!);
                    setIsUploadAsRealease(data.isUploadAsRealease!);
                    setAllUsers(data.adminUsers!);
                    setWorkspaceDescription(data.description!);
                }
            })
            .catch(err => {
                setSnackMesssage(err.response.data);
                setIsOpenSnack(true);
                setSnackSeverity("error");
            })
            .finally();
        }
    }

    function handleWorkspaceName(event: ChangeEvent<HTMLInputElement>) : void 
    {

        setWorkspaceName(event.target.value);
    }

    function handleWorkspaceDescription(event: ChangeEvent<HTMLInputElement>) : void 
    {
        setWorkspaceDescription(event.target.value);
    }

    function handleIsUploadAsRealease(e: React.ChangeEvent<HTMLInputElement>, checked: boolean) : void
    {
        if (checked)
        {
            setIsUploadAsRealease(true);
        } else
        {
            setIsUploadAsRealease(false);
        }
    }

    function handleIsAutomaticCAD(e: React.ChangeEvent<HTMLInputElement>, checked: boolean) : void
    {
        if (checked) 
        {
            setIsAutomaticCAD(true);
        } else
        {
            setIsAutomaticCAD(false);
        }
    }


    console.log(privilegeFollow);
    
    function handleIsPrivilegeFollow(e: React.ChangeEvent<HTMLInputElement>, checked: boolean) : void
    {
        if (checked) 
        {
            setPrivilegeFollow(true);
        } else
        {
            setPrivilegeFollow(false);
        }
    }

    function handleCreateUpdateWorkspace(workspace: WorkSpaceCreate)
    {
        if (idWorkspace != undefined) 
        {
            setRequestModal({
                isLoading: true,
                requestType: "PUT"
            });
            let createItem: WorkSpaceCreate = {
                adminUsers: allUsers,
                name: workspaceName,
                automaticViwerDwg: isAutomaticCAD,
                isUploadAsRealease: isUploadAsRealease,
                organizationName: nameOrg,
                description: workspaceDescription,
                id: idWorkspace,
                privilegeFollowWorkspaceRoot: privilegeFollow,
                ownerId: profile.id!,
                permission: workspace.permission
            };
            setWorkspaceCreate(createItem);

            Edit(createItem)
            .then((data) => {
                setSnackMesssage(t("Workspace.updateSuccess"));
                setIsOpenSnack(true);
                setSnackSeverity("success");
                setConclusionDialog(true);
            })
            .catch((err) => {
                setSnackMesssage(err.response.data);
                setIsOpenSnack(true);
                setSnackSeverity("error");
                setConclusionDialog(false);
            })
            .finally(() => {
                setRequestModal({
                    isLoading: false,
                    requestType: ""
                });
            })     
        } else
        {
            setRequestModal({
                isLoading: true,
                requestType: "POST"
            });            
            let createItem: WorkSpaceCreate = {
                adminUsers: allUsers,
                name: workspaceName,
                automaticViwerDwg: isAutomaticCAD,
                isUploadAsRealease: isUploadAsRealease,
                organizationName: nameOrg,
                description: workspaceDescription,
                privilegeFollowWorkspaceRoot: privilegeFollow,
                ownerId: profile.id!
            };
            setWorkspaceCreate(createItem);

            CreateWorkSpace(createItem)
            .then(() => {
                setSnackMesssage(t("Workspace.createSucess"));
                setIsOpenSnack(true);
                setSnackSeverity("success");
                setConclusionDialog(true);
            })
            .catch((err) => {
                setSnackMesssage(err.response.data);
                setIsOpenSnack(true);
                setSnackSeverity("error");
                setConclusionDialog(false);
            })
            .finally(() => {
                setRequestModal({
                    isLoading: false,
                    requestType: ""
                });
            })
        }
    }

    function handleModalBodyContent() : { title: string, content: string } 
    {
        switch(requestModal.requestType)
        {
            case "POST":
                return {
                    content: t("AdminConsole.CreatingYourWorkspace"),
                    title: t("AdminConsole.CreatingWorkspace")
                }
            case "PUT":
                return {
                    content: t("AdminConsole.UpdateYourWorkspace"),
                    title: t("AdminConsole.UpdatingWorkspace")
                }
            default:
                return {
                    content: "",
                    title: ""
                }
        }
    }

    return (
        <AdminConsoleWrapper>
            <BackButton
                backurl={`/${nameOrg}/adminConsole/workspaces`}
            />
            <ConfigWorkspaceHeader 
                handleCreate={handleCreateUpdateWorkspace}
                createItem={workspaceCreate}
                idWorkspace={idWorkspace}
                disabled={(workspaceName && workspaceName.length>=3)?false:true}
            />
            <Divider />

            <Grid container spacing={2} mt="5px" mb="30px">
                
                <Grid item xs={6} display="flex" justifyContent="center" alignItems="center">
                    <KeydriveTextfield
                        required
                        hintTextError={(workspaceName && workspaceName.length<3)?t("AdminConsole.ValidationWorkspaceName"):undefined}
                        onChange={handleWorkspaceName}
                        value={workspaceName}
                        needFullWidth
                        label={t("AdminConsole.WorkspaceName")}
                    />
                </Grid>
                <Grid item xs={6} display="flex" justifyContent="center" alignItems="center">
                    <KeydriveTextfield 
                        onChange={handleWorkspaceDescription}
                        value={workspaceDescription}
                        needFullWidth
                        label={t("AdminConsole.WorkspaceDescription")}
                    />
                </Grid>

            </Grid>
            <KeyDriveBodyMax 
                    color="#2D2D2D"
                    needBold
                    needEllipses={false}
                    text={t("AdminConsole.Participants")}
                />
            <WorkspaceUserConfig setAllUsersEx={setAllUsers}/>
            <Box
                mt="30px"
                mb="20px"
            >
                <KeyDriveBodyMax 
                    color="#2D2D2D"
                    needBold
                    needEllipses={false}
                    text={t("AdminConsole.Rules")}
                />
            </Box>
            <Box
                width="100%"
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                gap={1}
            >
                <RuleCard 
                    text={t("AdminConsole.UploadAsRealease")}
                    checked={isUploadAsRealease}
                    onChange={handleIsUploadAsRealease}
                />
                <RuleCard 
                    text={t("AdminConsole.CadBackground")}
                    checked={isAutomaticCAD}
                    onChange={handleIsAutomaticCAD}
                />
                <RuleCard 
                    text={t("AdminConsole.PrivilegeFollow")}
                    checked={privilegeFollow}
                    onChange={handleIsPrivilegeFollow}
                />
            </Box>
            <KeydriveSimpleModal 
                bodyContent={handleModalBodyContent().content}
                modalClose={() => {}}
                modalOpen={requestModal.isLoading}
                title={handleModalBodyContent().title}
                loading={requestModal.isLoading}
            />
            <KeyDriveDialog 
                keyDriveDialogButtons={{
                    leftButtonMethod: () => { setConclusionDialog(false) },
                    rightButtonMethod: () => {
                        setConclusionDialog(false);
                        navigate(`/${nameOrg}/adminConsole/workspaces/`);
                    },
                    rightButtonText: t("AdminConsole.Continue")
                }}
                keyDriveDialogContent={{
                    dialogContent: t("AdminConsole.CreatingYourWorkspaceDialog"),
                    dialogIcon: <CheckCircle sx={{ color: "#22638D", width: "44px", height: "44px" }}/>,
                    dialogTitle: t("AdminConsole.CreatingYourWorkspaceDialogTitle"),
                    handleTogglDialog: () => {},
                    openDialog: conclusionDialog
                }}
                dialogTitleCenter
            />
            <KeydriveSnackbar 
                message={snackMessage}
                open={isOpenSnack}
                variant={snackSeverity}
                onClose={handleClose}
            />
        </AdminConsoleWrapper>
    )
}